// extracted by mini-css-extract-plugin
export var awarded = "styles-module--awarded--1dc67";
export var button = "styles-module--button--6de98";
export var entries = "styles-module--entries--e34a1";
export var header = "styles-module--header--e972c";
export var projects = "styles-module--projects--3569e";
export var withoutMargin = "styles-module--withoutMargin--c9219";